import { UserOutlined, TeamOutlined, InboxOutlined, DashboardOutlined } from '@ant-design/icons';
import { displayMessage } from '../../helpers/messages';

export const sideMenuItensIconsStyle = { fontSize: 20 };

export const topMenuItensIconsStyle = { fontSize: 20 };

const menus = {
  // Menus laterais para todos os usuários
  userSideMenuItens: [
    {
      key: '/dashboard',
      icon: <DashboardOutlined style={sideMenuItensIconsStyle} />,
      title: 'Dashboard',
    },
    {
      key: '/batches',
      icon: <InboxOutlined style={sideMenuItensIconsStyle} />,
      title: displayMessage('BATCHES'),
    },
    {
      key: '/clients',
      icon: <TeamOutlined style={sideMenuItensIconsStyle} />,
      title: displayMessage('CLIENTS'),
    },
    {
      key: '/users',
      icon: <UserOutlined style={sideMenuItensIconsStyle} />,
      title: displayMessage('USERS'),
    },
  ],

  // Menus administrativos (se necessário)
  adminSideMenuItens: [],

  // Menus do topo (perfil, etc)
  topMenuItens: [
    {
      key: '/profile',
      icon: <UserOutlined style={topMenuItensIconsStyle} />,
      title: displayMessage('MY_PROFILE'),
    },
  ],
};

export default menus;



